import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Drawer from '../../UI/Drawer/Drawer';
import Clickable from '../../UI/Clickable/Clickable';
import SidebarElement from './SidebarElement/SidebarElement';
import classes from './Sidebar.module.css';
import { parseIndex } from '../../../utils';

const Sidebar = ({ show, onCloseSidebar }) => {
  const history = useHistory();
  const hub = useSelector((state) => state.hub.hub);
  if (!hub) return null;
  const { sections } = hub;
  const navigateHandler = (link, defaultSubsection) => {
    history.push(`${link}${defaultSubsection ? `/${defaultSubsection}` : ''}`);
    onCloseSidebar();
  };
  return (
    <Drawer show={show} side="left" closeWithBackdrop={false}>
      <div className={classes.sidebar}>
        <div className={classes.header}>
          <img className={classes.logo} src={hub.logo[0].url} alt="navLogo" />
          <span className={classes.title}>CONTENT HUB</span>
          <Clickable onClick={onCloseSidebar} className={classes.closeBtn}>
            <img
              className={classes.closeImage}
              src="/images/cross.svg"
              alt="hamburger"
            />
          </Clickable>
        </div>
        {sections
          .filter(({ name }) => name !== 'Builder Coupon')
          .map(({ name, link, defaultSubsection }, i) => (
            <SidebarElement
              key={name}
              label={name}
              onClick={() => navigateHandler(link, defaultSubsection)}
              index={parseIndex(i)}
            />
          ))}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  show: PropTypes.bool.isRequired,
  onCloseSidebar: PropTypes.func.isRequired,
};

export default Sidebar;
